import { useNumberFormat } from 'hooks/useNumberFormat';
import { FunctionComponent } from 'react';

interface VehicleDetailCommentsSubAverageItemProps {
  label: string;
  average: number;
}

const VehicleDetailCommentsSubAverageItem: FunctionComponent<
  VehicleDetailCommentsSubAverageItemProps
> = ({ average, label }) => {
  const { numberLocaleFormat } = useNumberFormat();

  const ratingRange = 5 - 1;
  const averageWithRange = average - 1 > 4 ? 4 : average - 1;
  const totalLength = 160;
  const filledLength = Math.floor(
    (totalLength / ratingRange) * averageWithRange
  );

  return (
    <div className="text-sm">
      <span className="inline-block w-32">{label}</span>
      <span
        className="relative mr-2 inline-block h-2 rounded-full bg-slate-300"
        style={{ width: `${totalLength}px` }}
      >
        <span
          className="absolute top-0 left-0 inline-block h-2 rounded-full bg-primary-500"
          style={{ width: `${filledLength}px` }}
        />
      </span>
      <span>{numberLocaleFormat(average)}</span>
    </div>
  );
};

export default VehicleDetailCommentsSubAverageItem;
